__turbopack_context__.v({
  "error": "InputCheckbox-module-scss-module__ccnFDa__error",
  "input": "InputCheckbox-module-scss-module__ccnFDa__input",
  "label": "InputCheckbox-module-scss-module__ccnFDa__label",
  "svg": "InputCheckbox-module-scss-module__ccnFDa__svg",
});
